export const actionTypes = {
  // get Email Tempalte
  GET_EMAIL_TEMPLATE_START: 'GET_EMAIL_TEMPLATE_START',
  GET_EMAIL_TEMPLATE_SUCCESS: 'GET_EMAIL_TEMPLATE_SUCCESS',
  GET_EMAIL_TEMPLATE_FINISH: 'GET_EMAIL_TEMPLATE_FINISH',

  // add Email Tempalte
  ADD_EMAIL_TEMPLATE_START: 'ADD_EMAIL_TEMPLATE_START',
  ADD_EMAIL_TEMPLATE_SUCCESS: 'ADD_EMAIL_TEMPLATE_SUCCESS',
  ADD_EMAIL_TEMPLATE_FINISH: 'ADD_EMAIL_TEMPLATE_FINISH',
  RESET_EMAIL_TEMPLATE: 'RESET_EMAIL_TEMPLATE',

  // update Email Tempalte
  UPDATE_EMAIL_TEMPLATE_START: 'UPDATE_EMAIL_TEMPLATE_START',
  UPDATE_EMAIL_TEMPLATE_SUCCESS: 'UPDATE_EMAIL_TEMPLATE_SUCCESS',
  UPDATE_EMAIL_TEMPLATE_FINISH: 'UPDATE_EMAIL_TEMPLATE_FINISH',

  // delete Email Tempalte
  DELETE_EMAIL_TEMPLATE_START: 'DELETE_EMAIL_TEMPLATE_START',
  DELETE_EMAIL_TEMPLATE_SUCCESS: 'DELETE_EMAIL_TEMPLATE_SUCCESS',
  DELETE_EMAIL_TEMPLATE_FINISH: 'DELETE_EMAIL_TEMPLATE_FINISH',
}
